import styled, { keyframes } from 'styled-components';

interface DotLoaderProps {
    size?: number; // Diameter of each dot
    gap?: number;  // Space between dots
    color?: string; // Color of the dots
}

const waveAnimation = keyframes`
    0%, 60%, 100% {
        transform: scale(1);
    }
    30% {
        transform: scale(1.3);
    }
`;

const Dot = styled.div<{ size: number; color: string; animationDelay: string }>`
    width: ${({ size }) => size}px;
    height: ${({ size }) => size}px;
    background-color: ${({ color }) => color};
    border-radius: 50%;
    animation: ${waveAnimation} 1.2s ease-in-out infinite;
    animation-delay: ${({ animationDelay }) => animationDelay};
`;

const DotContainer = styled.div<{ gap: number }>`
    display: inline-flex;
    align-items: center;
    gap: ${({ gap }) => gap}px;
`;

export function DotLoader({
    size = 3,
    gap = 3,
    color = '#c9c9c9',
}: DotLoaderProps) {
    return (
        <DotContainer gap={gap}>
            <Dot size={size} color={color} animationDelay="0s" />
            <Dot size={size} color={color} animationDelay="0.2s" />
            <Dot size={size} color={color} animationDelay="0.4s" />
        </DotContainer>
    );
}
